import { IMenuItem } from "@/components/Header";

import { faFileChartColumn } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Paper, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import PageLayout from "../components/layout/PageLayout";

const PaperHeading = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(0, 0, 2, 0),
    font: 'roboto',
    fontWeight: 200,
}));


const PaperContainer = styled(Paper)(({ theme }) => ({
    padding: theme.spacing("24px"),
    borderRadius: "4px",
    boxShadow: theme.palette.mode === 'dark' ? 'none' : theme.shadows[1],
}));

const PaperButton = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
        boxShadow: 4,
        backgroundColor: '#421f5e'
    },
    margin: theme.spacing(1, 50, 2, 0),
}));




const Index = () => {
    const [report, setReport] = useState<IMenuItem[]>([]);


    useEffect(() => {
        const fetchData = async () => {  

            const items: IMenuItem[] = [
                {
                    url: '/biobank',
                    label: 'BCT Biobank',
                    external: false,
                    newTab: true,
                    icon: faFileChartColumn
                }
            ];

            setReport(items);
        };

        fetchData();
    }, []);

    const navigate = useNavigate();

    const SelectReportTable = () => (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            {report.map((item, index) => (
                <Grid key={index}>
                    <PaperButton
                        onClick={() => navigate(item.url)}
                        sx={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            transition: '0.2s',
                        }}
                    >
                        <FontAwesomeIcon icon={item.icon} size="lg" color="white" />
                        <Typography color="white" variant="subtitle1">{item.label}</Typography>
                    </PaperButton>
                </Grid>
            ))}
        </Grid>
    );

    return (
        <PageLayout  
            heading="Translational Research"
        >
            <PaperContainer>
                <PaperHeading variant="h5">
                    Biological specimens from breast cancer trials – opportunities for further research
                </PaperHeading>

                <Typography fontWeight="bold" variant="body1">
                    The BCT Biobank is an extensive resource that provides opportunities for local researchers to conduct analyses on samples with accompanying clinical outcome data. This has the potential in turn to influence the development of new BCT clinical research.
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    Patients who participate in clinical trials often make very generous contributions of blood samples and tissue from their cancer, which are then analysed as part of that research project. who participate in clinical trials often make very generous contributions...
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    In many cases part of the donated samples are left over after the planned research is complete. This represents a great opportunity for other researchers to learn more about breast cancer. These learnings can then be fed back into the development of new clinical trials that aim to find out if a new type of treatment can improve the lives of people with breast cancer around the world.
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    Breast Cancer Trials has a biobank in Newcastle that holds thousands of specimens from the trials they conduct that can be used for scientific research. These specimens are linked to richly detailed information about the trial participants’ cancer and treatment-related outcomes that assists with understanding the relevance of laboratory-based research findings.
                </Typography>

                <Typography
                    variant="body1"
                    fontStyle="italic"
                    fontWeight="bold"
                    sx={{ mt: 2 }}
                >
                    Supported in part by grants from the Breast Cancer Research Foundation (BCRF) since 2010.
                </Typography>

                <SelectReportTable />
            </PaperContainer>
        </PageLayout>
    );
};

export default Index;
